import rsvpModelReducer from '../../helpers/rsvp-model-reducer';
import contactModelReducer from '../../../contacts/helpers/contact-model-reducer.js';

export default class RsvpQuickEditController {
    constructor($uibModalInstance, $scope, $injector, rsvpId, guestlistInformation) {
        this.scope = $scope;
        this.modalInstance = $uibModalInstance;
        this.injector = $injector;
        this.rsvpId = rsvpId;
        this.hideCustomRsvpCode = true;

        this.error = this.injector.get('Error');
        this.alert = this.injector.get('Alert');

        this.api = this.injector.get('$http');
        this.depositService = this.injector.get('Deposit');
        this.filter = this.injector.get('$filter');
        this.rootScope = this.injector.get('$rootScope');

        this.loading = true;
        this.model = {rsvp: {}, contact: {}};
        this.guestlistInformation = {};
        this.companyProfile = {};

        this.deposits = {
            countries: {},
            languages: {},
            genders: {},
            states: {}
        };
        this.submitting = false;

        this.fields = [];

        this._init();
    }

    _init() {
        this._loadDeposits();

        this.loadCompanyProfile().then(() => {
            this.contactCustomFields = _(this.companyProfile)
                .map((value, attr) => {
                    if (attr.match(/custom_\d*_name/gi) && _.keys(value).length) {
                        value.key = attr.match(/custom_\d*/gi)[0];
                        return value;
                    }
                })
                .filter()
                .value();
        });

        return this._loadRsvp().then(() => {
            this.rsvpCustomFields = _(this.guestlistInformation)
                .map((value, attr) => {
                    if (attr.match(/custom_\d*_name/gi) && _.keys(value).length) {
                        value.key = attr.match(/custom_\d*/gi)[0];
                        return value;
                    }
                })
                .filter()
                .value();
        });
    }

    _loadRsvp() {
        this.loading = true;
        this.model = {rsvp: {}, contact: {}};

        return this.api.get(`rsvps/${this.rsvpId}?include=guestlist,contact`).then((response) => {
            this.loading = false;
            this.model.rsvp = rsvpModelReducer(_.get(response, 'data.data'), _.get(response, 'data.data.guestlist.data')) /*['guestlist', 'contact']);*/
            this.model.contact = contactModelReducer(_.get(response, 'data.data.contact.data'), this.injector.get('Users').state.company);
            this.guestlistInformation = _.get(response, 'data.data.guestlist.data');

            this.guestlistInformation.settings.enabled_fields.forEach(function (field) {
                let keys = field.split('.');
                let formatedField = this.guestlistInformation.enabled_fields[keys[0]][keys[1]];
                if (formatedField.type === 'bool') {
                    formatedField.type = 'boolean';
                }
                if (formatedField.type === 'string') {
                    formatedField.type = formatedField.multiline ? 'textarea' : 'textbox';
                    if (formatedField.enum) {
                        formatedField.type = 'select';
                        formatedField.name = formatedField.label;
                        if (formatedField.name === 'Sex') {
                            formatedField.enum = Object.values(formatedField.enum).map(o => o.toLowerCase());
                        } else {
                            formatedField.enum = Object.values(formatedField.enum);
                        }
                    }
                }
                if (formatedField.type === 'image') {
                    formatedField.type = 'media_image';
                }
                if (formatedField.type === 'file') {
                    formatedField.type = 'media_file';
                }
                if (formatedField.type === 'color-codes') {
                    formatedField.type = 'color_code_select';
                    formatedField.enum = Object.values(formatedField.enum);
                }
                if (formatedField.type === 'float') {
                    formatedField.type = 'decimal';
                }

                formatedField.name = formatedField.label;
                this.fields.push(
                    {...formatedField, key:keys[1], parent:keys[0]}
                );
            }.bind(this));

        });
    }

    loadCompanyProfile() {
        return this.api.get(`auth/profile?include=company`).then((response) => {
            this.companyProfile = response.data.data.company.data;
        }, (e) => {
            return e;
        })
    }

    _loadDeposits() {
        this.depositService.getRemoteDeposit('contacts', 'countries', []).then((value) => {
            this.deposits.countries = value;
        });
        this.depositService.getRemoteDeposit('contacts', 'languages', []).then((value) => {
            this.deposits.languages = value;
        });
        this.depositService.getRemoteDeposit('contacts', 'genders', []).then((value) => {
            this.deposits.genders = value;
        });
        this.depositService.getRemoteDeposit('rsvps', 'states', []).then((value) => {
            this.deposits.states = value;
        });
    }

    isFieldEnabled(slug, searchPartial) {
        // const fields = this.model.rsvp.parent_rsvp_id ? this.guestlistInformation.settings.registration_guest_fields : this.guestlistInformation.settings.registration_fields;
        // return (this.filter('filter')(fields, {slug: slug}, !searchPartial).length > 0);
        const enabledFields = this.guestlistInformation.settings.enabled_fields;
        if (searchPartial) {
            for (let i = 0; i < enabledFields.length; i++) {
                if (_.startsWith(enabledFields[i], slug)) {
                    return true;
                }
            }
        } else {
            return enabledFields.indexOf(slug) !== -1;
        }
    }

    save(form) {
        if (!form.$valid) {
            return;
        }
        this.submitting = true;

        if (!this.model.pax_planned || this.model.pax_planned < 1) {
            this.model.pax_planned = 1;
        }

        const contactData = _.clone(this.model.contact),
            rsvpData = _.clone(this.model.rsvp);

        this.api.put(`contacts/${this.model.contact.id}`, contactData).then((response) => {
            const contact = response.data.data;
            rsvpData.contact_id = contact.id;

            this.api.put(`rsvps/${this.model.rsvp.id}`, rsvpData).then((response) => {
                this.modalInstance.close({
                    contact: contact,
                    rsvp: response.data.data
                });
            }, (e) => {
                this.submitting = false;
                this.alert.handle(e);
            }).finally(() => {
                this.submitting = false;
            })
        }, (e) => {
            this.submitting = false;
            this.alert.handle(e);
        });
    };

    cancel() {
        this.modalInstance.dismiss();
    };
}

RsvpQuickEditController.$inject = [
    '$uibModalInstance',
    '$scope',
    '$injector',
    'rsvpId'
];



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/components/extended-info/quick-edit-custom-controller.js